module.exports = __webpack_public_path__ + "img/patient-landing-dashboard.cf9c7192.svg";